<div class="container">
  <section class="introduction">
    <h1>SR Logistics India Private Limited</h1>
    <p>At SR Logistics India Private Limited, we specialize in end-to-end warehousing and
      transportation solutions, with a strong emphasis on safety, precision, and adherence to client-
      specific Standard Operating Procedures (SOPs)
    </p>
    <p>Our committed team meticulously plans and executes every step of the supply chain with
      great care, going above and beyond to complete all tasks precisely as requested and on
      schedule, thereby consistently exceeding client expectations. Our fleet is rigorously
      monitored to guarantee safe and prompt transportation of goods. We maintain strict
      compliance with both internal protocols and client directives, prioritizing the safety and
      security of each consignment and the safety of our employees</p>
    <p>Our warehousing solutions are tailored to meet the unique needs of each client, taking into
      account important factors like size and location. We tailor our warehousing operations to the
      distinct needs of every client, integrating the necessary systems, processes, and technologies
      to manage storage, handling, and distribution efficiently. These components are essential and
      directly influence the operational efficiency, cost optimization, and customer satisfaction. We
      make sure that the most suitable space is available to ensure that operations run smoothly and
      in coordination, while maintaining the highest level of safety and striving to optimise
      inventory and minimise delays. This ensures an efficient operational management and a
      seamless and well-coordinated workflow, allowing our personnel to concentrate on their
      work in a secure and stress-free environment
    </p>
    <p>In order to meet the needs of our clients, we have a workforce comprising of more than 60
      well-trained professionals, including managers, supervisors, warehouse staff, and skilled
      computer operators. We operate seamlessly within our clients’ digital ecosystems, utilizing
      platforms such as Keris JDE, SAP, Tally, and more</p>
  </section>

  <!-- Grid for images -->
  <section class="image-grid">
    <div class="grid">
      <div class="grid-item" *ngFor="let image of images">
        <img [src]="image.src" [alt]="image.alt" loading="lazy" (click)="openImageOverlay(image.src)"
          (contextmenu)="onImageRightClick($event)">
      </div>
    </div>
    <div class="image-overlay" *ngIf="selectedImage" (click)="closeImageOverlay()">
      <img [src]="selectedImage" alt="Enlarged image" (contextmenu)="onImageRightClick($event)">
      <span class="close-btn" (click)="closeImageOverlay()">&times;</span>
    </div>
  </section>
</div>